// http://www.w3schools.com/js/js_cookies.asp
// Set a browser cookie
export function setCookie(cname, cvalue, exdays, domain = undefined) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  let cookieStr = cname + "=" + cvalue + "; " + expires + ";path=/";
  if (domain) {
    cookieStr += ";domain=" + domain;
  }
  document.cookie = cookieStr;
}

export function removeCookie(cname, domain = undefined) {
  setCookie(cname, false, -1, domain);
}

// Get a browser cookie
export function getCookie(cname) {
  const name = cname + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
